const baseUri = 'categories';

export default {
  show(slug) {
    return api.get(`${baseUri}/${slug}`);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/category.js